import { WeatherLabelProps } from "./types";
import { Weather } from "../../types/variables/Variables";
import translations from "../../components/translations";

export const WeatherLabel: React.FC<WeatherLabelProps> = ({ weather, selectedLanguage }) => {
    switch (weather?.toLowerCase()) {
        case Weather.SUNNY:
            return <>{translations[selectedLanguage].sunny}</>;

        case Weather.CLOUDY:
            return <>{translations[selectedLanguage].cloudy}</>;

        case Weather.PARTLY_CLOUDY:
            return <>{translations[selectedLanguage].partly_cloud}</>;

        case Weather.RAINY:
            return <>{translations[selectedLanguage].rainy}</>;

        case Weather.PARTLY_RAINY:
            return <>{translations[selectedLanguage].partly_rainy}</>;

        case Weather.STORMY:
            return <>{translations[selectedLanguage].stormy}</>;

        case Weather.THUNDERSTORM:
            return <>{translations[selectedLanguage].thunderstorm}</>;

        default:
            return <>{translations[selectedLanguage].unknown_weather}</>;
    }
};
